import { Variants } from '../types/variant';

export const kinesitherapieVariants = {
  kinesitherapie: {
    name: 'KINE',
    status: 'beta',
    description:
      "Questionnaire d'anamnèse kinésithérapique avant la première séance. Socle commun (motif, douleur, retentissement fonctionnel, objectifs, antécédents, signes d'alerte) puis onze modules déclenchés par le type de rééducation ou déduits du socle.",
    speciality: 'KINE',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DIRECT_CONFIRMATION',
    emailTemplate: 'MED_G_DEFAULT',
    // Plain-text "letter", même parti pris que la radiologie
    // interventionnelle : le kinésithérapeute lit une synthèse continue, pas
    // une grille de cartes. Pas de gate par version — la spécialité naît avec
    // ce rendu, il n'existe aucun rapport antérieur à préserver.
    reportTemplate: 'KINESITHERAPY_PLAIN',
    initialQuestions: [],
    initialAssertions: [],
    pages: {
      // L'ordre des pages est celui de la trame : administratif, prescription
      // et routage, motif, retentissement, antécédents, puis les modules
      // conditionnels et enfin les habitudes de vie.
      ADMINISTRATIVE: {
        title: 'Vous',
        sections: ['ADMINISTRATIF'],
      },
      CONSULTATION: {
        title: 'Prescription',
        sections: ['INTRODUCTION'],
      },
      COMPLAINTS: {
        title: 'Motif',
        sections: ['MOTIF', 'DOULEUR'],
      },
      IMPACT: {
        title: 'Retentissement',
        sections: ['RETENTISSEMENT', 'OBJECTIFS'],
      },
      HISTORY: {
        title: 'Antécédents',
        sections: ['ANTECEDENTS', 'ALERTES'],
      },
      // Les onze modules partagent une page : au plus quelques-uns sont
      // ouverts pour un patient donné, les autres sections restent vides.
      // L'ordre des sections ici fixe l'ordre de parcours entre modules.
      MODULES: {
        title: 'Bilan kiné',
        sections: [
          'MOD_RACHIS',
          'MOD_MEMBRE_SUP',
          'MOD_MEMBRE_INF',
          'MOD_RESPIRATOIRE',
          'MOD_NEURO',
          'MOD_VESTIBULAIRE',
          'MOD_POSTOP',
          'MOD_SPORTIF',
          'MOD_RHUMATO',
          'MOD_GERIATRIE',
          'MOD_PALLIATIF',
        ],
      },
      LIFESTYLE: {
        title: 'Habitudes de vie',
        sections: ['HABITUDES'],
      },
      CONCLUSION: {
        title: 'Conclusion',
        sections: ['CONCLUSION'],
      },
    },
    options: [],
    // The KB emits `§ Motif de consultation` (singular). Without this both
    // motive paths miss it and come back empty: `getCleanMotives` reads
    // `report.data['Motifs']` (report.service.ts) and `extractMotiveReason`
    // defaults to 'Motifs de consultation' (report-formatter.service.ts).
    visitMotivesSection: 'Motif de consultation',
  },
} satisfies Variants;
